/**
 * @desc 获取品种树
 */
import { KindDetail, KindPageQuery } from '@eastcoal/api/system/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryKindTreeParameter = KindPageQuery

const method = 'GET'
const url = '/system/kind/tree'

export const queryKindTreeApi = (
  params?: QueryKindTreeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<KindDetail>>({
    method,
    url,
    params,
    ...config
  })
}

queryKindTreeApi.method = method
queryKindTreeApi.url = url
